module.exports = __webpack_public_path__ + "static/media/writer.4befdc73.jpg";